/**
 * ThemeBadge is the gift theme selection button. It has three main uses/states:
 * 1. the user has selected a theme (in /send or /gift), then is shows the selected theme as bg and shows gift icon
 * 2. the success page after a gift transaction, the button should be not clickable, but renders with selected theme and gift icon
 */

import PropTypes from 'prop-types'

import React from 'react'
import classNames from 'classnames'
import { StyleSheet, css } from 'lib/paypalphrodite'
import { getThemeImage } from '../utils/theme-utils'

const styles = StyleSheet.create({
  badgeWrapper: {
    display: 'block',
    width: '100%',
    textAlign: 'center',
    height: 65,
    cursor: 'pointer',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    border: 'none',
    borderRadius: 5,
    color: 'white',
    padding: 21,
  },
  themeOpacity: {
    ':hover': {
      transition: 'opacity 600ms ease',
      opacity: 0.6,
    },
  },
  disableClick: {
    outline: 'none',
    cursor: 'auto',
  },
})

class ThemeBadge extends React.Component {
  static propTypes = {
    handleClick: PropTypes.func,
    selectedThemeId: PropTypes.string,
    disableClick: PropTypes.bool,
  }

  static defaultProps = {
    handleClick: () => {},
    selectedThemeId: '',
    disableClick: false,
  }

  render() {
    const { handleClick, selectedThemeId, disableClick } = this.props

    const wrapperClassNames = {
      [css(styles.badgeWrapper)]: true,
      [css(styles.disableClick)]: disableClick,
      [css(styles.themeOpacity)]: !disableClick,
    }

    const bgImage = getThemeImage(selectedThemeId, 'p2p')

    return (
      <button
        onClick={handleClick}
        type="button"
        style={{ background: `url(${bgImage})` }}
        data-a11y-overpanel-focus-target="theme-selection-close"
        className={classNames(wrapperClassNames)}
      />
    )
  }
}

export default ThemeBadge
